function convertName(name: string): string {
  const map: Record<string, string> = {
    kochi: 'kouchi',
    donan: 'dounan',
    dohoku: 'douhoku',
    doo: 'douou',
    dotou: 'doutou'
  }
  return map[name] ?? name
}

export function getAreaKeyByPrefKey(prefKey: string) {
  if (prefKey === 'okinawa') {
    return 'okinawa'
  }
  for (const area of areaToPrefTable) {
    if (area.pref_list.some((pref: { key: string }) => pref.key === prefKey)) {
      return area.key
    }
  }
}

function buildAreaPath(area: string, pref: string): string {
  if (area === 'okinawa') {
    return `/${area}/`
  }
  return `/${area}/${pref}/`
}

async function findKeyById(id: string): Promise<string | null> {
  const data = await $fetch('/api/golf/info')
  for (const [key, item] of Object.entries(data)) {
    const typedItem = item as { id: string }
    if (typedItem.id === id) {
      return key
    }
  }
  return null
}

async function handleCgiRedirect(to: Parameters<typeof defineNuxtRouteMiddleware>[0] extends (...args: infer A) => unknown ? A[0] : never) {
  const id = to.query.id
  if (!id) return navigateTo('/', { redirectCode: 301 })
  try {
    const key = await findKeyById(id as string)
    if (key) return navigateTo(key, { redirectCode: 301 })
    return navigateTo('/', { redirectCode: 301 })
  } catch (error) {
    console.error('古いurlからのリダイレクト時のエラー:', error)
    return navigateTo('/', { redirectCode: 301 })
  }
}

function handleHtmlRedirect(pathParam: string) {
  const pref = convertName(pathParam)
  const areaMatch = pref.match(/^([a-zA-Z0-9_-]+)-area$/)
  if (areaMatch && areaMatch[1]) {
    const area = convertName(areaMatch[1])
    return navigateTo(`/${area}/`, { redirectCode: 301 })
  }
  const area = getAreaKeyByPrefKey(pref)
  if (area) {
    return navigateTo(buildAreaPath(area, pref), { redirectCode: 301 })
  }
  return navigateTo('/', { redirectCode: 301 })
}

async function handleXmlRedirect(pathParam: string) {
  const param = convertName(pathParam)
  if (param === 'whole-country') {
    return navigateTo('/', { redirectCode: 301 })
  }
  const areaMatch = param.match(/^([a-zA-Z0-9_-]+)-area$/)
  if (areaMatch && areaMatch[1]) {
    const area = convertName(areaMatch[1])
    return navigateTo(`/${area}/`, { redirectCode: 301 })
  }
  const area = getAreaKeyByPrefKey(param)
  if (area) {
    return navigateTo(buildAreaPath(area, param), { redirectCode: 301 })
  }
  const key = await findKeyById(param)
  if (key) return navigateTo(key, { redirectCode: 301 })
  return navigateTo('/', { redirectCode: 301 })
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path === '/cgi/search_result.fcgi/') {
    return handleCgiRedirect(to)
  }
  const htmlMatch = to.path.match(/^\/(?:golf\/)?html\/([a-zA-Z0-9_-]+)\.html\/?$/)
  if (htmlMatch && htmlMatch[1]) {
    return handleHtmlRedirect(htmlMatch[1])
  }
  const xmlMatch = to.path.match(/^\/(?:golf\/)?xml\/([a-zA-Z0-9_-]+)\.xml\/?$/)
  if (xmlMatch && xmlMatch[1]) {
    return handleXmlRedirect(xmlMatch[1])
  }
})
